import request from './axios';

/**
 * 获取首页幻灯片
 * @returns {Promise<Object>} 
 */
export function getAdvertiseList(data,params) {
  return request({
    url: '/no-auth/txt/advertise/list',
    method: 'post',
    data,
    params
  });
}

/**
 * 获取画册列表
 * @returns {Promise<Object>} 
 */
export function getAlbumList(data,params) {
  return request({ 
    url: '/no-auth/txt/album/list',
    method: 'post',
    data,
    params
  });
}


/**
 * 搜索
 * @returns {Promise<Object>} 
 */
export function getSearch(params){
  return request({
    url: `/no-auth/search`,
    method: 'get',
    params
  });
}

/**
 * 首页分类
 * @returns {Promise<Object>} 
 */
export function getHomeCate(){
  return request({
    url: `/no-auth/home/cate`,
    method: 'get'
  });
}


